import * as actionTypes from 'store/actionTypes/User'

export const setAuth = payload => {
    return {
        type: actionTypes.SET_USER_AUTENTICATED,
        payload,
    }
}

export const setUserInfo = payload => {
    return {
        type: actionTypes.SET_USER_INFO,
        payload,
    }
}

export const setTokens = payload => {
    return {
        type: actionTypes.SET_USER_AUTH_TOKENS,
        payload,
    }
}

export const setUserType = payload => {
    return {
        type: actionTypes.SET_USER_TYPE,
        payload,
    }
}

export const setMyAvatar = payload => {
    return {
        type: actionTypes.SET_MY_AVATAR,
        payload,
    }
}

export const logout = () => {
    return {
        type: actionTypes.PERFORM_LOGOUT,
    }
}

export const setQRCodeData = data => ({
    type: actionTypes.SET_QR_CODE_DATA,
    data,
})
